export default __webpack_public_path__ + "asset/img/default~f47b59cf.png";